import { Layout } from 'antd';
import { CountryHolidayManager } from './CountryHolidayManager';

export const CountryHolidaysPageView = () => {
  return (
    <Layout>
      <CountryHolidayManager />
    </Layout>
  );
};
